import { render, staticRenderFns } from "./BaseEditorBlock.vue?vue&type=template&id=a784e676&scoped=true"
import script from "./BaseEditorBlock.vue?vue&type=script&lang=js"
export * from "./BaseEditorBlock.vue?vue&type=script&lang=js"
import style0 from "./BaseEditorBlock.vue?vue&type=style&index=0&id=a784e676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a784e676",
  null
  
)

export default component.exports